"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnlineSearchDocumentSchema = exports.StoreCategorySchema = exports.StoreProductSchema = exports.StoreVariantSchema = exports.StoreStockStateSchema = exports.ChannelPricingSchema = void 0;
const zod_1 = require("zod");
// ── Pricing router output (UNIFIED-MODEL §4) ──
// Carries {price, taxId, feeId, promotionId, pricingModelId, compliancePresetId}.
// taxId/feeId are pluralized (taxIds/feeIds) to match the live APosChannelConfig
// which stores arrays. `null` from priceForRequest means "not visible".
exports.ChannelPricingSchema = zod_1.z.object({
    price: zod_1.z.number().positive(),
    taxIds: zod_1.z.array(zod_1.z.string()).default([]),
    feeIds: zod_1.z.array(zod_1.z.string()).default([]),
    promotionId: zod_1.z.string().optional(),
    pricingModelId: zod_1.z.string().optional(),
    compliancePresetId: zod_1.z.string().optional(),
});
exports.StoreStockStateSchema = zod_1.z.enum(['in_stock', 'low_stock', 'out_of_stock']);
// ── Read DTOs returned by /store/* endpoints ──
exports.StoreVariantSchema = zod_1.z.object({
    variantId: zod_1.z.string(),
    productId: zod_1.z.string(),
    displayName: zod_1.z.string(),
    sku: zod_1.z.string().optional(),
    pricing: exports.ChannelPricingSchema,
    stockState: exports.StoreStockStateSchema,
    stockLeft: zod_1.z.number().int().optional(),
    attributes: zod_1.z.record(zod_1.z.string()).default({}),
    thumbnailUrl: zod_1.z.string().optional(),
});
exports.StoreProductSchema = zod_1.z.object({
    productId: zod_1.z.string(),
    name: zod_1.z.string(),
    slug: zod_1.z.string(),
    categoryId: zod_1.z.string().optional(),
    categoryName: zod_1.z.string().optional(),
    description: zod_1.z.string().default(''),
    images: zod_1.z.array(zod_1.z.string()).default([]),
    variants: zod_1.z.array(exports.StoreVariantSchema),
    // Product with Options / Clothing: level names + values in display order.
    optionLevels: zod_1.z.array(zod_1.z.object({ name: zod_1.z.string(), values: zod_1.z.array(zod_1.z.string()) })).optional(),
});
exports.StoreCategorySchema = zod_1.z.object({
    categoryId: zod_1.z.string(),
    name: zod_1.z.string(),
    slug: zod_1.z.string(),
    imageUrl: zod_1.z.string().nullable().optional(),
});
// ── Typesense `products-online-{tenantId}` document ──
exports.OnlineSearchDocumentSchema = zod_1.z.object({
    id: zod_1.z.string(), // `${productId}_${variantId}`
    productId: zod_1.z.string(),
    variantId: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    name: zod_1.z.string(),
    displayName: zod_1.z.string(),
    slug: zod_1.z.string(),
    categoryId: zod_1.z.string(),
    categoryName: zod_1.z.string(),
    sku: zod_1.z.string(),
    description: zod_1.z.string(),
    onlinePrice: zod_1.z.number(),
    images: zod_1.z.array(zod_1.z.string()),
    thumbnailUrl: zod_1.z.string(),
    inStock: zod_1.z.boolean(),
    attributes: zod_1.z.record(zod_1.z.string()),
    updatedAt: zod_1.z.number(),
    reviewAvg: zod_1.z.number().optional(),
    reviewCount: zod_1.z.number().optional(),
});
//# sourceMappingURL=channel-pricing.schema.js.map